import {
  WEBSOCKET_CONNECT,
  WEBSOCKET_DISCONNECT,
  WEBSOCKET_SEND_MESSAGE,
  WEBSOCKET_CHANGE_STATUS,
  WEBSOCKET_NEW_MESSAGE,
  WEBSOCKET_NEW_MESSAGE_FILE,
  WEBSOCKET_USER_ONLINE,
  WEBSOCKET_USER_OFFLINE,
  WEBSOCKET_CHECK_USER_ONLINE,
} from 'stores/types';

const initialState = {
  status: 'off'
};

const websocket = ( state = initialState, action ) => {
  switch( action.type ) {
    case WEBSOCKET_CHANGE_STATUS:
      console.log('redux', action)
      return {
        ...state,
        status: action.data.status,
        data: action.data.data ? action.data.data : state.data,
      };
    case WEBSOCKET_CONNECT:
      return {
        ...state,
        connected: true,
      };
    case WEBSOCKET_DISCONNECT:
      console.log('redux', action)
      return {
        status: 'off',
        connected: false,
      };
    case WEBSOCKET_SEND_MESSAGE:
      return {
        ...state,
        messageData: action.data,
      };
    case WEBSOCKET_NEW_MESSAGE:
      if ( !action.data ) return { ...state, newMessageData: null };
      return {
        ...state,
        newMessageData: action.data,
        newMessageDataDate: new Date().valueOf()
      };
    case WEBSOCKET_NEW_MESSAGE_FILE:
      if ( !action.data ) return { ...state, newMessageFileData: null };
      return {
        ...state,
        newMessageFileData: action.data,
        newMessageFileDataDate: new Date().valueOf()
      };
    case WEBSOCKET_USER_ONLINE:
      return {
        ...state,
        online: action.data,
      };
    case WEBSOCKET_USER_OFFLINE:
      return {
        ...state,
        online: null,
      };
    case WEBSOCKET_CHECK_USER_ONLINE:
      return {
        ...state,
        checkOnlineData: action.data,
      };
    default:
      return state;
  }
};

module.exports = websocket;



// WEBPACK FOOTER //
// ./stores/reducers/common/websocket.js